import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  tagText: {
    fontWeight: 500,
    fontSize: 12,
  },
}));
